import React, { useState, useEffect } from 'react';
import { withResizeDetector } from 'react-resize-detector';
import { Normal } from 'components/Core/Typography';
import { STGlyphTertiary } from 'components/Brand/Logos/STGlyph';
import { FeatureWheelContainer, FeatureWheelItemContainer, FeatureWheelItem } from './styles';

const FeatureWheel = props => {
  const {
    features,
    selIndex,
    onItemClick,
    width,
    height,
    logoWidth = 120,
    logoHeight = 120,
    itemWidth = 75,
    itemHeight = 75,
    focusIconScale = 1.6,
  } = props;
  const [rotate, setRotate] = useState(0);
  const [prevIndex, setPrevIndex] = useState(selIndex);
  const featureCount = features.length;
  const radius = (width - 50) / 2;
  const step = (2 * Math.PI) / featureCount;
  const oneAngle = 360 / featureCount;

  useEffect(() => {
    let diff = selIndex < prevIndex ? selIndex + featureCount - prevIndex : selIndex - prevIndex;
    diff = diff > featureCount / 2 ? diff - featureCount : diff;
    setRotate(rotate + oneAngle * diff);
    setPrevIndex(selIndex);
  }, [selIndex]);

  const handleClick = index => {
    if (index === selIndex) {
      return;
    }

    onItemClick(index);
  };

  return (
    <FeatureWheelContainer height={width} logoWidth={logoWidth} logoHeight={logoHeight}>
      <div className="feature-wheel--wheel-logo">
        <STGlyphTertiary />
      </div>
      <FeatureWheelItemContainer transform={rotate}>
        {features &&
          features.length > 0 &&
          features.map((feature, index) => {
            const angle = index * step;
            const x = Math.round(width / 2 - radius * Math.cos(angle) - itemWidth / 2) || 'NaN';
            const y = Math.round(height / 2 + radius * Math.sin(angle) - itemHeight / 2) || 'NaN';

            return (
              <FeatureWheelItem
                className="feature-wheel--wheel-item"
                width={itemWidth}
                height={itemHeight}
                focusIconScale={focusIconScale}
                x={x}
                y={y}
                isActive={index === selIndex}
                onClick={() => handleClick(index)}
                transform={parseFloat(rotate)}
                key={index}
              >
                <Normal className="feature-wheel--wheel-item-tooltip">{feature.title}</Normal>
                <img
                  className="feature-wheel--wheel-item-icon"
                  src={feature.icon}
                  alt={feature.title}
                />
              </FeatureWheelItem>
            );
          })}
      </FeatureWheelItemContainer>
    </FeatureWheelContainer>
  );
};

export default withResizeDetector(FeatureWheel);
